<div class="container">
    <div class="row mb-4" style="color: #222;">
        <div class="col-12">
            <article class="sheet" role="document" aria-label="Target Details">
                <!-- HEADER -->
                <header class="sheet-header">
                    <div class="title">
                        <h1>{{ target().TargetName }}</h1>
                        <small class="muted">Target instructions &amp; details</small>
                    </div>
                    <div class="d-flex align-items-center gap-2 justify-content-end">
                        @if (showGraph()) {
                            <button pButton class="p-button-outlined side-menu-button2" 
                                    icon="pi pi-arrow-left" (click)="onHideGraph()"
                                    [style]="{ border: '1px solid currentColor' }">
                                &nbsp;See Instructions
                            </button>
                        } @else {
                            <button pButton class="p-button-outlined side-menu-button2" 
                                    icon="pi pi-chart-line" (click)="onSeeGraphs()"
                                    [style]="{ border: '1px solid currentColor' }">
                                &nbsp;See Graphs
                            </button>
                        }
                    </div>
                </header>

                <!-- Show Graphs -->
                @if (showGraph()) {
                    <section class="section">
                        <div class="panel bg-blue">
                            <h3 class="pillhead bg-blue-2">Target Graph</h3>
                            <app-target-graph 
                                [patientID]="target().PatientID?.toString()!" 
                                [selectedTargets]="[target()]">
                            </app-target-graph>
                        </div>
                    </section>
                } @else {
                    @if (lightLoad.isEnabled()) {
                    <section class="section">
                        <div class="panel bg-blue">
                            <p class="p-3 text-muted">Instructions and notes are skipped in Light Load to save memory.</p>
                        </div>
                    </section>
                    }

                    <!-- Target Notes -->
                    @if (!lightLoad.isEnabled()) {
                    <section class="section target-notes-section">
                        <div class="panel bg-blue target-notes-panel">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h3 class="pillhead bg-blue-2">Target Notes</h3>
                            </div>
                            <app-target-note-thread
                                [target]="target()"
                                [readOnly]="isPreview()"
                                [shouldMarkAsNew]="true"
                            ></app-target-note-thread>
                        </div>
                    </section>
                    }
                    <!-- Target Instructions -->
                    @if (!lightLoad.isEnabled()) {
                    <section class="section">
                        <div class="panel bg-blue">
                            <h3 class="pillhead bg-blue-2">Target Instructions</h3>
                            @if (isLoadingContent() && target().Instructions == null) {
                                <div class="d-flex align-items-center gap-2 text-muted p-3" role="status">
                                    <div class="spinner-border spinner-border-sm text-primary" aria-hidden="true"></div>
                                    <span>Loading target instructions...</span>
                                </div>
                            } @else {
                                <div class="ck ck-content bg-white text-black p-5 instructions-content"
                                     [innerHTML]="target().Instructions | safeHtml">
                                </div>
                            }
                        </div>
                    </section>
                    }

                    <!-- BSP Current Objective -->
                    @if (target().BSP_SkillAcquisitionGoalID || target().SkillAcquisitionGoal_Other) {
                        <section class="section">
                            <div class="panel bg-blue">
                                <h3 class="pillhead bg-blue-2">BSP Current Objective</h3>
                                <p class="d-block wrap-text">{{ target().BSP_SkillAcquisitionGoalName ?? target().SkillAcquisitionGoal_Other }}</p>
                            </div>
                        </section>
                    }

                    <!-- Treatment Goals -->
                    @if (target().BSP_SkillAcquisitionGoalID && target().TreatmentGoals && (target().TreatmentGoals?.length ?? 0) > 0) {
                        <section class="section">
                            <div class="panel bg-blue">
                                <h3 class="pillhead bg-blue-2">Treatment Goals that support this objective</h3>
                                @for (goal of target().TreatmentGoals; track goal) {
                                    <div class="ms-3 d-flex align-items-center gap-2 mb-2">
                                        <div class="d-block wrap-text">- {{ goal }}</div>
                                    </div>
                                }
                            </div>
                        </section>
                    }

                    <!-- Attachments -->
                    @if (!lightLoad.isEnabled() && !isOfflineMode() && (isLoadingAttachments() || attachmentList().length > 0)) {
                        <section class="section">
                            <div class="panel bg-blue">
                                <h3 class="pillhead bg-blue-2">Attachments</h3>
                                @if (isLoadingAttachments() && attachmentList().length === 0) {
                                    <div class="d-flex align-items-center gap-2 text-muted p-3" role="status">
                                        <div class="spinner-border spinner-border-sm text-primary" aria-hidden="true"></div>
                                        <span>Loading attachments...</span>
                                    </div>
                                }
                                <div class="att-list-container background-set-white border-small-rounded mt-3">
                                    @for (att of attachmentList(); track att.ID) {
                                        <div class="att-box" role="button" (click)="openAttachmentView(att)">
                                            @if (att.IsImage) {
                                                <img class="m-2" [src]="getImageUrl(att)" 
                                                     style="min-width: 40px; min-height: 40px; max-width: 40px; max-height: 40px;">
                                            } @else {
                                                <i class="m-0 p-0 pi pi-file-o" style="font-size: 25px; color: black;"></i>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        </section>
                    }

                }
            </article>
        </div>
    </div>
</div>

<!-- Attachment View -->
<app-attachment-view
    [doShowAttachmentView]="doShowAttachmentView()"
    [attachment]="selectedAttachment()"
    [canDelete]="false"  
    [view]="'patientInstructionAttachment'"
    (close)="closeAttachmentView()"
></app-attachment-view>

